'use client'
import Image from 'next/image'
import { useTranslations } from 'next-intl'
import { BaseEmptyStateProps } from '../types'
import { CMSButton } from '../../CMSButton'

export const EmptySuccess: React.FC<BaseEmptyStateProps> = ({ button, hasButton }) => {
  const t = useTranslations('emptyStates.success')

  return (
    <div className="bg-bg-base rounded-md p-card-s max-w-[438px]">
      <div className="">
        <div className="relative w-full h-[274px]">
          <Image
            src={'/emptyStates/new-user-content-illustration.svg'}
            alt={t('description')}
            fill
            style={{ aspectRatio: '16/10' }}
            className="object-contain"
          />
        </div>
        <div className="mt-6">
          <p className="text-body-S-regular text-text-base">{t('description')}</p>
        </div>
        <div className="flex">
          {hasButton && button && <CMSButton {...button} appearance="primary" size="md" />}
        </div>
      </div>
    </div>
  )
}
